import { useTranslation } from 'react-i18next'

import Select from '@/components/Select/Select'
import { useAllEducationLevels } from '@/queries/useAllEducationLevels'
import type { FormFieldType } from '@/types/form-field-type'

const EducationLevelSelect = (props: FormFieldType<string>) => {
  const { t } = useTranslation('coursesManagement')
  const { data, isLoading } = useAllEducationLevels()

  return (
    <Select
      {...props}
      loading={isLoading}
      options={data?.options ?? []}
      placeholder={t('placeholder.select-education-level')}
    />
  )
}

export default EducationLevelSelect
